import { normalizeWhatsappNo } from "./sabil-household-members";

/** Form / API shape helpers shared between sabil edit audit checks. */
export function findHolderMember(
  members: Array<{
    isHof?: boolean | null;
    itsNo?: string | null;
    name?: string | null;
    whatsappNo?: string | null;
  }>
): { itsNo: string; name: string; whatsappNo: string } | null {
  const holder = members.find((member) => member.isHof === true);
  if (!holder) {
    return null;
  }
  return {
    itsNo: String(holder.itsNo ?? "").trim(),
    name: String(holder.name ?? "").trim(),
    whatsappNo: normalizeWhatsappNo(holder.whatsappNo),
  };
}

export { normalizeWhatsappNo, isMuttavatteenSabilType } from "./sabil-household-members";
